module.exports = __webpack_public_path__ + "img/img_title@2x.78ccd4ed.png";